import * as React from "react";
import moment from "moment";
import { Link } from "react-router-dom";

import SearchInput from "../../../components/uiMerge/searchInput";
import SearchIcon from "../../../assets/wallet/search-icon.png";
import Pointicons from "../../../assets/svg/tinyPointsIcon.svg";
import { TemplateSub } from "../../../components/layouts/TemplateSub";
import { CustomerTransactions, Transaction } from "@njoy/controller";
import RedemptionSkeleton from "./RedemptionSkeleton";

const headings = [
  { key: "week", label: "Last 7 Days" },
  { key: "month", label: "Last 30 Days" },
  { key: "year", label: "All" },
];

// const Points = [
//   {
//     id: "1",
//     borderColor: "#046E0D",
//     backgroundcolor: "#DAFFB4",
//     point: "+45",
//   },
//   {
//     id: "2",
//     borderColor: "#44046E",
//     backgroundcolor: "#ECDAFF",
//     point: "+6",
//   },
//   {
//     id: "3",
//     borderColor: "",
//     backgroundcolor: "",
//     point: "",
//   },
// ];

export const RedemptionHistoryPage: React.FC = () => {
  const [currentPage, setCurrentPage] = React.useState<string>("week");
  const [search, setSearch] = React.useState("");

  const variables = {
    offset: 0,
    limit: 20,
    duration: currentPage,
    typeFilter: "Free Redemption",
    searchText: search || undefined, // <-- add searchText to variables
  };

  const subscribeRef = React.useRef<null | (() => () => void)>(null);
  React.useEffect(() => {
    if (subscribeRef.current) {
      const unsubscribe = subscribeRef.current();
      return () => {
        if (unsubscribe) unsubscribe();
      };
    }
    return undefined;
  }, [currentPage]);

  return (
    <TemplateSub page="Redemption History">
      <div className="w-full flex-1 h-full overflow-y-auto pb-4">
        <div className="w-full flex-1 overflow-y-auto pb-7">
          {/* Navigation Tabs */}
          <div className="w-full flex gap-2 justify-center items-center p-4 ">
            {headings.map((tab) => (
              <div
                key={tab.key}
                className={`text-[12px] max-[430px]:px-3 shadow py-3 px-7 text-center w-full h-[42] rounded-[10px] text-white cursor-pointer transition duration-300 ${
                  currentPage === tab.key
                    ? " bg-[linear-gradient(270deg,var(--brand-gradient-from)_0%,var(--brand-gradient-to)_98.3%)] font-semibold"
                    : "bg-[#3C3E58]"
                }`}
                onClick={() => setCurrentPage(tab.key)}
              >
                {tab.label}
              </div>
            ))}
          </div>

          {/* Search Input */}
          <div className="w-full px-[1rem] mt-0">
            <SearchInput
              prefixIcon={
                <img src={SearchIcon} alt="search" width={20} height={20} />
              }
              id="search"
              name="search"
              type="search"
              placeholder="Search Redemption"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className=" px-5 flex justify-between items-center gap-5 mt-0"
              end2end={false}
            />
          </div>

          <CustomerTransactions variables={variables}>
            {({ myTransactions, loading, loadMore, hasMoreTransactions }) => {
              // Group by date
              const grouped = myTransactions.reduce(
                (acc, tx) => {
                  const date = moment(tx.createdAt).format("YYYY-MM-DD");
                  if (!acc[date]) acc[date] = [];
                  acc[date].push(tx);
                  return acc;
                },
                {} as Record<string, typeof myTransactions>,
              );

              console.log("my transactions ", grouped);
              return (
                <>
                  <div className="px-[1rem] mt-6">
                    {loading && (
                      <div className="flex flex-col gap-3">
                        <RedemptionSkeleton />
                        <RedemptionSkeleton />
                        <RedemptionSkeleton />
                      </div>
                    )}

                    {Object.keys(grouped).length === 0 && !loading && (
                      <div className="text-[#9fafb5] text-center mt-8">
                        No redemption found.
                      </div>
                    )}

                    {Object.entries(grouped).map(([date, txs], idx) => (
                      <div
                        key={date}
                        className={`w-full p-3 bg-[#1E1E1E] ${
                          idx === 0 ? "mt-[2rem]" : "mt-[1rem]"
                        } rounded-lg`}
                      >
                        <p className="text-white text-[13px] text-left">
                          {moment(date, "YYYY-MM-DD").format("Do MMMM YYYY")}
                        </p>
                        <hr className="bg-[#77777] mt-3 border w-full border-[#7777]" />
                        <div className="flex flex-col gap-3 w-full p-2">
                          {(txs as Transaction[]).map((tx) => (
                            <Link
                              key={tx.id}
                              to={`/redemption-details/${tx.id}`}
                            >
                              <div className="flex justify-between gap-1 items-center cursor-pointer">
                                <div className="flex mt-3 items-center  gap-4 ">
                                  <div>
                                    <img
                                      src={
                                        tx.offer?.createdBy?.admin
                                          ?.merchantProfile?.logoUrl || ""
                                      }
                                      alt=""
                                      width={27}
                                      height={27}
                                      className="rounded-full object-cover w-[27px] h-[27px]"
                                    />
                                  </div>
                                  <div className="flex flex-col gap-1 min-w-0">
                                    <div className="w-full ">
                                      <p className="text-[12px] text-white font-semibold">
                                        {(tx?.offer?.title ?? "").slice(0, 30)}
                                        {(tx?.offer?.title ?? "").length > 30 &&
                                          "..."}
                                      </p>
                                    </div>

                                    <p className="text-[#777] text-[12px]">
                                      {
                                        tx.offer?.createdBy?.admin
                                          ?.merchantProfile?.companyName
                                      }
                                    </p>
                                  </div>
                                </div>

                                <div className="flex gap-[2px] flex-col justify-end items-end mt-2">
                                  <p className="text-[11px] text-[#777] ">
                                    {moment(tx.offer?.createdAt).format(
                                      "h:mm A",
                                    )}
                                  </p>

                                  <div className="flex gap-1 items-center">
                                    {/* <div className="flex gap-[2px] px-1 py-[2px] items-center bg-[#DAFFB4] border border-[#046E0D] rounded">
                                      <img
                                        src={Pointicons}
                                        height={9}
                                        width={9}
                                        alt=""
                                      />
                                      <p className="text-[8px] text-[#046E0D]">
                                        + {tx.point}
                                      </p>
                                    </div> */}

                                    <div className="flex items-center gap-[0.2rem] px-1 py-[0.17rem] bg-[#DAFFB4] border border-[#046E0D] rounded w-fit max-w-full">
                                      <img
                                        src={Pointicons}
                                        alt=""
                                         height={12}
                                        width={12}
                                        // className="w-2 h-2 sm:w-4 sm:h-4 object-contain"
                                      />
                                      <p className="text-[12px] sm:text-xs text-[#046E0D] font-medium whitespace-nowrap">
                                        +{tx?.point ?? 0}
                                      </p>
                                    </div>

                                    <div className="bg-[#343434] px-[6px] py-[1px] rounded min-w-0">
                                      <p className="text-[10px] text-[#B4B4B4] w-full truncate ">
                                        {tx.offer?.offerType}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              );
            }}
          </CustomerTransactions>
        </div>
      </div>
    </TemplateSub>
  );
};
